import React from "react";
import PortfolioCard from "./PortfolioCard"; // Import PortfolioCard component
import portfolioItems from "./portfolioData"; // Import portfolio items data

const Portfolio = () => (
  <div className="w-full min-h-screen bg-gray-900 py-16 px-4">
    <h1 className="text-4xl md:text-5xl font-title font-extrabold text-center mb-12 text-white">
      Our Portfolio
    </h1>
    
    {/* Container for portfolio items */}
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 w-full md:w-[90%] mx-auto">
      {portfolioItems.map((item, index) => (
        <div
          key={item.id}
          className={
            index === 0
              ? "md:col-span-3 lg:col-span-3"
              : ""
          }
        >
          <PortfolioCard {...item} />
        </div>
      ))}
    </div>
  </div>
);

export default Portfolio;
